import BEV from './BEV.js';

const getBevRateLevel = (bevRateName) => {
  return BEV.tariff_elements.pge_subscription_rate.find((rate) => rate.name === bevRateName);
};

export default getBevRateLevel;
